<div class="h-100 d-flex flex-column">
    @if (showSearch) {
        <div class="flex-shrink-0">
            <molecule-search-and-filter-bar
                [searchType]="searchType"
                [searchTypePlural]="searchTypePlural"
                [placeholder]="searchPlaceholder"
                [totalRecordCount]="table | fn: getResultsCount : tablePaging"
                [filterHandler]="filterHandler"
                [filterFormId]="filterFormId"
                [inputSearchText]="
                    filterHandler && filterHandler.getSearchText()
                "
                [sortMenu]="table | fn: getSortMenu"
                [isLoading]="isLoading"
                [showSearchBar]="showSearchBar"
                [hasMobileFilter]="hasMobileFilter"
                [hasFilterSearch]="hasFilterSearch"
                (searchTriggered)="onSearch($event)"
                (sort)="onSort($event)"
            >
                <ng-content
                    prefixActionButtons
                    select="[prefixActionButtons]"
                ></ng-content>
                @if (legend) {
                    <div class="legend">
                        <div class="divider-start divider--short">
                            <molecule-legend
                                [items]="legend"
                                [hasContainer]="false"
                            ></molecule-legend>
                        </div>
                    </div>
                }
                <ng-content actionButtons select="[actionButtons]"></ng-content>
                @if (searchBarActionButtons?.length) {
                    <ng-container actionButtons>
                        @for (
                            actionButton of searchBarActionButtons;
                            track $index;
                            let first = $first;
                            let last = $last
                        ) {
                            <molecule-action-button
                                btnClass="btn-primary"
                                size="md"
                                [filterHandler]="filterHandler"
                                [class.ms-lg-2]="first"
                                [class.me-lg-2]="!last"
                                [actionButton]="actionButton"
                                [isDisabled]="actionButton?.isDisabled"
                                (onClick)="
                                    onActionButtonClicked($event, actionButton)
                                "
                            >
                                @if (actionButton.label) {
                                    <div class="action-button-add">
                                        {{ actionButton.label }}
                                    </div>
                                }
                            </molecule-action-button>
                        }
                    </ng-container>
                }
            </molecule-search-and-filter-bar>
            <hr />
        </div>
    }

    @if (!infinityScrollFired.observers.length && tablePaging) {
        <div
            class="d-flex align-items-center justify-content-between flex-shrink-0 body-text-medium mb-3"
        >
            <div class="d-flex align-items-center">
                <span>{{ SHOW_LABEL | translateTokenisedString }}</span>
                <molecule-context-menu-dropdown
                    class="d-block mx-2"
                    btnClass="btn"
                    [menu]="pageLengthMenu"
                    [initialValue]="pageLengthMenuDefaultValue"
                ></molecule-context-menu-dropdown>
                <span>{{ RESULTS_LABEL | translateTokenisedString }}</span>
            </div>
            <div>
                @if (tablePaging?.totalRecords) {
                    {{ SHOWING_LABEL | translateTokenisedString }}
                    {{
                        tablePaging?.page
                            | fn: getResultCountFrom : tablePaging?.pageSize
                    }}
                    {{ TO_LABEL | translateTokenisedString }}
                    {{
                        tablePaging?.page
                            | fn
                                : getResultCountTo
                                : tablePaging?.pageSize
                                : tablePaging?.totalRecords
                    }}
                    {{ OF_LABEL | translateTokenisedString }}
                }
                {{ tablePaging?.totalRecords ?? 0 }}
                {{ RESULTS_LABEL | translateTokenisedString }}
            </div>
        </div>
    }

    <div
        #scrollContainer
        class="flex-grow-1 position-relative overflow-auto"
        data-cy="list-client"
        [clmiInfiniteScroll]="table?.pagingType === PAGING_TYPE?.InfiniteScroll"
        (scrolled)="onInfinityScrollFired()"
    >
        <atom-async-data
            [isLoading]="isLoading"
            [hasError]="hasError"
            [isForInfinityScroll]="
                table?.pagingType === PAGING_TYPE?.InfiniteScroll &&
                infinityScrollFired?.observers?.length &&
                table?.rows?.length
            "
            [overlayContent]="
                table?.pagingType !== PAGING_TYPE?.InfiniteScroll && tablePaging
            "
        >
            @if (table?.rows?.length) {
                @if (key && key?.length) {
                    <div
                        [ngClass]="{
                            'table-key--responsive content-separation-border content-separation-border-lg-0 mb-lg-2':
                                'displayMode === TABLE_DISPLAY_MODE.ResponsiveTable',
                            'table-key--table mb-2':
                                'displayMode === TABLE_DISPLAY_MODE.Table',
                        }"
                        [class.table__key--responsive]="
                            displayMode === TABLE_DISPLAY_MODE?.ResponsiveTable
                        "
                        [class.table__key--table]="
                            displayMode === TABLE_DISPLAY_MODE?.Table
                        "
                        [class.table__key--small]="isSmall"
                    >
                        <molecule-legend
                            class="overline"
                            label="Key:"
                            [items]="key"
                            [hasContainer]="false"
                            [responsiveOrientation]="false"
                        ></molecule-legend>
                    </div>
                }
                @if (isMobileView$ | ngrxPush) {
                    @if (displayMode === TABLE_DISPLAY_MODE?.ResponsiveCards) {
                        @for (card of tableRows; track $index) {
                            @if (card.responsiveCard?.templateRef) {
                                <ng-container
                                    *ngTemplateOutlet="
                                        card.responsiveCard.templateRef;
                                        context: {
                                            data: card.responsiveCard.data,
                                        }
                                    "
                                ></ng-container>
                            }
                        }
                    }
                    @if (displayMode === TABLE_DISPLAY_MODE?.ResponsiveTable) {
                        <table class="table table-sm">
                            @for (
                                card of tableRows;
                                track $index;
                                let firstRow = $first;
                                let cardIndex = $index
                            ) {
                                @if (
                                    !rowLimit ||
                                    (rowLimit &&
                                        (rowLimit <= 0 ||
                                            (rowLimit > 0 &&
                                                cardIndex < rowLimit)))
                                ) {
                                    <tbody
                                        [class.card-selectable]="
                                            canSelectRows || canToggleRows
                                        "
                                        (click)="onRowClicked(card)"
                                    >
                                        @if (canSelectRows) {
                                            <tr>
                                                @if (table.headers?.length) {
                                                    <th
                                                        class="pt-2 border-0"
                                                        scope="row"
                                                    ></th>
                                                }
                                                <td
                                                    class="d-flex justify-content-end border-0 me-1"
                                                >
                                                    <ng-container
                                                        *ngTemplateOutlet="
                                                            rowSelector;
                                                            context: {
                                                                row: card,
                                                                index: cardIndex,
                                                            }
                                                        "
                                                    ></ng-container>
                                                </td>
                                            </tr>
                                        }
                                        @if (canToggleRows && !canSelectRows) {
                                            <tr>
                                                @if (table.headers?.length) {
                                                    <th
                                                        class="pt-2 border-0"
                                                        scope="row"
                                                    ></th>
                                                }
                                                <td
                                                    class="d-flex justify-content-end border-0 pt-2 me-1"
                                                >
                                                    <ng-container
                                                        *ngTemplateOutlet="
                                                            rowToggle;
                                                            context: {
                                                                row: card,
                                                            }
                                                        "
                                                    ></ng-container>
                                                </td>
                                            </tr>
                                        }
                                        @for (
                                            value of card.values;
                                            track $index;
                                            let valueIndex = $index;
                                            let firstValue = $first;
                                            let lastValue = $last
                                        ) {
                                            <tr>
                                                @if (table.headers?.length) {
                                                    <th
                                                        class="border-0 text-nowrap pr-2"
                                                        scope="row"
                                                        [class.pt-2]="
                                                            firstValue &&
                                                            !canSelectRows
                                                        "
                                                        [class.pb-2]="lastValue"
                                                    >
                                                        {{
                                                            table.headers[
                                                                valueIndex
                                                            ]?.value
                                                                | truncateText
                                                                    : 16
                                                        }}
                                                    </th>
                                                }
                                                <td
                                                    class="border-0"
                                                    [class.pt-2]="
                                                        firstValue &&
                                                        !canSelectRows
                                                    "
                                                    [class.pb-2]="lastValue"
                                                >
                                                    <div
                                                        class="d-flex align-items-center"
                                                    >
                                                        <ng-container
                                                            *ngTemplateOutlet="
                                                                tableValue;
                                                                context: {
                                                                    value: value,
                                                                    avatarSize:
                                                                        'sm',
                                                                }
                                                            "
                                                        ></ng-container>
                                                    </div>
                                                </td>
                                            </tr>
                                        }
                                        @if (
                                            card.toggleRowTemplate?.visible &&
                                            !canSelectRows
                                        ) {
                                            <tr class="bg-gray-100">
                                                <td
                                                    class="bg-gray-100"
                                                    [attr.colspan]="
                                                        table?.headers?.length +
                                                        1
                                                    "
                                                >
                                                    <ng-container
                                                        *ngTemplateOutlet="
                                                            card
                                                                .toggleRowTemplate
                                                                .templateRef;
                                                            context: {
                                                                data: card
                                                                    .toggleRowTemplate
                                                                    .data,
                                                            }
                                                        "
                                                    ></ng-container>
                                                </td>
                                            </tr>
                                        }
                                    </tbody>
                                }
                            }
                        </table>
                    }
                }
                @if (!(isMobileView$ | ngrxPush)) {
                    <table
                        data-cy="table-client"
                        class="table"
                        [class.table-hover]="hoverableTable"
                        [class.table-sm]="
                            isSmall || (responsiveIsSmall$ | ngrxPush)
                        "
                    >
                        @if (table.headers?.length) {
                            <thead>
                                <tr>
                                    @if (canSelectRows || canToggleRows) {
                                        <th
                                            class="table__select-head"
                                            role="col"
                                        >
                                            <wdx-checkbox
                                                [checked]="
                                                    selectedRows.length ===
                                                    table.rows?.length
                                                "
                                                [indeterminate]="
                                                    selectedRows.length > 0 &&
                                                    selectedRows.length <
                                                        table.rows?.length
                                                "
                                                (isChecked)="selectAllRows()"
                                            ></wdx-checkbox>
                                        </th>
                                    }
                                    @for (
                                        header of table.headers;
                                        track $index;
                                        let headingColIndex = $index
                                    ) {
                                        <th
                                            role="col"
                                            [id]="header.id || ''"
                                            [ngClass]="{
                                                'd-none d-lg-table-cell':
                                                    hideColumnIndexesOnSmallScreen.length >
                                                        0 &&
                                                    hideColumnIndexesOnSmallScreen.includes(
                                                        headingColIndex
                                                    ),
                                            }"
                                        >
                                            <div
                                                class="d-flex align-items-center"
                                                [class.pointer]="
                                                    header.sortByFieldName
                                                "
                                                (click)="onHeaderClick(header)"
                                            >
                                                @if (header.sortByFieldName) {
                                                    <div
                                                        class="ms-n1 me-1 d-flex"
                                                    >
                                                        @if (
                                                            filterHandler?.getSortBy() ===
                                                            header.sortByFieldName
                                                        ) {
                                                            @if (
                                                                filterHandler?.getSortDirection() ===
                                                                SORT_DIRECTION.Ascending
                                                            ) {
                                                                <wdx-icon
                                                                    class="align-items-center d-flex icon-container-size-md justify-content-center"
                                                                    icon="chevron-up"
                                                                ></wdx-icon>
                                                            }
                                                            @if (
                                                                filterHandler?.getSortDirection() ===
                                                                SORT_DIRECTION.Descending
                                                            ) {
                                                                <wdx-icon
                                                                    class="align-items-center d-flex icon-container-size-md justify-content-center"
                                                                    icon="chevron-down"
                                                                ></wdx-icon>
                                                            }
                                                        } @else {
                                                            <wdx-icon-stack
                                                                class="pt-3"
                                                                icon
                                                            >
                                                                @for (
                                                                    icon of DEFAULT_SORT_ICON;
                                                                    track $index
                                                                ) {
                                                                    <wdx-icon
                                                                        class="align-items-center d-flex justify-content-center"
                                                                        [scale]="
                                                                            0.6
                                                                        "
                                                                        [icon]="
                                                                            icon
                                                                        "
                                                                    ></wdx-icon>
                                                                }
                                                            </wdx-icon-stack>
                                                        }
                                                    </div>
                                                }
                                                <span>{{
                                                    header.translationKey
                                                        ? (header.translationKey
                                                          | translateTokenisedString)
                                                        : header.value
                                                }}</span>
                                            </div>
                                        </th>
                                    }
                                </tr>
                            </thead>
                        }
                        <tbody>
                            @for (
                                row of tableRows;
                                track $index;
                                let rowIndex = $index
                            ) {
                                @if (
                                    !rowLimit ||
                                    (rowLimit &&
                                        (rowLimit <= 0 ||
                                            (rowLimit > 0 &&
                                                rowIndex < rowLimit)))
                                ) {
                                    @if (!row.formSetup) {
                                        <tr
                                            [ngClass]="{
                                                'router-link-row':
                                                    row.routerLink ||
                                                    canSelectRows ||
                                                    canToggleRows,
                                                selected:
                                                    row.toggleRowTemplate
                                                        ?.visible ||
                                                    (selectedRows
                                                        | fn
                                                            : rowIsSelected
                                                            : row),
                                            }"
                                            [attr.draggable]="canDragRows"
                                            (dragstart)="dragstart(rowIndex)"
                                            (dragenter)="
                                                dragenter($event.target)
                                            "
                                            (dragleave)="
                                                dragleave(
                                                    $event.target,
                                                    rowIndex
                                                )
                                            "
                                            (dragover)="dragover($event)"
                                            (dragend)="dragend()"
                                            (click)="onRowClicked(row)"
                                            data-cy="table-row"
                                        >
                                            <ng-container
                                                *ngTemplateOutlet="
                                                    rowTemplate;
                                                    context: { row: row }
                                                "
                                            ></ng-container>
                                        </tr>
                                    }
                                    @if (row.formSetup) {
                                        <tr
                                            class="router-link-row"
                                            [clmiUiDynamicFormSetup]="
                                                row.formSetup
                                            "
                                        >
                                            <ng-container
                                                *ngTemplateOutlet="
                                                    rowTemplate;
                                                    context: { row: row }
                                                "
                                            ></ng-container>
                                        </tr>
                                    }
                                    @if (
                                        row.toggleRowTemplate?.visible &&
                                        !canSelectRows
                                    ) {
                                        <tr class="bg-gray-100">
                                            <td
                                                class="bg-gray-100 p-0"
                                                [attr.colspan]="
                                                    table?.headers?.length + 1
                                                "
                                            >
                                                <ng-container
                                                    *ngTemplateOutlet="
                                                        row.toggleRowTemplate
                                                            .templateRef;
                                                        context: {
                                                            data: row
                                                                .toggleRowTemplate
                                                                .data,
                                                        }
                                                    "
                                                ></ng-container>
                                            </td>
                                        </tr>
                                    }
                                    <ng-template #rowTemplate let-row="row">
                                        @if (canDragRows) {
                                            <td role="col">
                                                <div class="drag-handle">
                                                    <wdx-icon
                                                        class="icon-container d-flex justify-content-center align-items-center icon-container-size-lg"
                                                        icon="grip-vertical"
                                                    ></wdx-icon>
                                                    <div
                                                        class="drag-handle-overlay"
                                                    ></div>
                                                </div>
                                            </td>
                                        }
                                        @for (
                                            value of row.values;
                                            track $index;
                                            let colIndex = $index;
                                            let first = $first
                                        ) {
                                            @if (canSelectRows && first) {
                                                <td
                                                    [ngClass]="{
                                                        'd-none d-lg-table-cell':
                                                            hideColumnIndexesOnSmallScreen.length >
                                                                0 &&
                                                            hideColumnIndexesOnSmallScreen.includes(
                                                                colIndex
                                                            ),
                                                    }"
                                                >
                                                    <ng-container
                                                        *ngTemplateOutlet="
                                                            rowSelector;
                                                            context: {
                                                                row: row,
                                                                index: rowIndex,
                                                            }
                                                        "
                                                    ></ng-container>
                                                </td>
                                            }
                                            @if (
                                                colIndex === 0 &&
                                                highlightFirstColumn
                                            ) {
                                                <th
                                                    scope="row"
                                                    [ngClass]="{
                                                        'd-none d-lg-table-cell':
                                                            hideColumnIndexesOnSmallScreen.length >
                                                                0 &&
                                                            hideColumnIndexesOnSmallScreen.includes(
                                                                colIndex
                                                            ),
                                                    }"
                                                    [class.no-wrap]="
                                                        value.noWrap
                                                    "
                                                    [class.w-100]="
                                                        value.fillSpace
                                                    "
                                                >
                                                    <div
                                                        class="d-flex align-items-center {{
                                                            value.format
                                                                ? 'table-format--' +
                                                                  value.format
                                                                : ''
                                                        }}"
                                                    >
                                                        <ng-container
                                                            *ngTemplateOutlet="
                                                                tableValue;
                                                                context: {
                                                                    value: value,
                                                                    avatarSize:
                                                                        'lg',
                                                                }
                                                            "
                                                        ></ng-container>
                                                    </div>
                                                </th>
                                            } @else {
                                                @if (
                                                    first &&
                                                    row.toggleRowTemplate &&
                                                    !canSelectRows
                                                ) {
                                                    <td class="px-0">
                                                        <ng-container
                                                            *ngTemplateOutlet="
                                                                rowToggle;
                                                                context: {
                                                                    row: row,
                                                                }
                                                            "
                                                        ></ng-container>
                                                    </td>
                                                }
                                                <td
                                                    [ngClass]="{
                                                        'd-none d-lg-table-cell':
                                                            hideColumnIndexesOnSmallScreen.length >
                                                                0 &&
                                                            hideColumnIndexesOnSmallScreen.includes(
                                                                colIndex
                                                            ),
                                                    }"
                                                    [class.no-wrap]="
                                                        value.noWrap
                                                    "
                                                    [class.w-100]="
                                                        value.fillSpace
                                                    "
                                                    [attr.data-label]="
                                                        table?.headers[colIndex]
                                                            ?.id || ''
                                                    "
                                                >
                                                    <div
                                                        class="d-flex align-items-center {{
                                                            value.format
                                                                ? 'table-format--' +
                                                                  value.format
                                                                : ''
                                                        }}"
                                                        [attr.data-cy]="
                                                            'list-cell-' +
                                                                table?.headers[
                                                                    colIndex
                                                                ]?.value || ''
                                                        "
                                                    >
                                                        <ng-container
                                                            *ngTemplateOutlet="
                                                                tableValue;
                                                                context: {
                                                                    value: value,
                                                                    avatarSize:
                                                                        'sm',
                                                                }
                                                            "
                                                        ></ng-container>
                                                    </div>
                                                </td>
                                            }
                                        }
                                    </ng-template>
                                }
                            }
                        </tbody>
                    </table>
                }
            } @else {
                @if (!isLoading && !hasError) {
                    <div
                        class="h-100 w-100 d-flex align-items-center justify-content-center"
                    >
                        <atom-feature-svg
                            [size]="noDataSvgSize"
                            [svg]="FEATURE_SVG.NoData"
                            data-cy="no-record-found"
                        >
                            {{
                                SVG_TEXT_NO_RECORD_FOUND
                                    | translateTokenisedString
                            }}
                        </atom-feature-svg>
                    </div>
                }
            }
        </atom-async-data>

        @if (
            !disableMultiselectBanner &&
            showMultiSelectBanner &&
            canSelectRows &&
            !canSelectOnlyOneRow
        ) {
            <molecule-multiselect-banner
                class="multiselect-banner start-0 bottom-0 position-{{
                    multiselectBannerPosition
                }}"
                [actionButtons]="multiselectBannerButtons"
                [position]="multiselectBannerPosition"
                [container]="elementRef"
                [selectedCount]="selectedRows.length"
                [totalItems]="table | fn: getResultsCount : tablePaging"
                (actionButtonClicked)="onMultiselectActionButtonClicked($event)"
                (close)="closeMultiselectBanner()"
            ></molecule-multiselect-banner>
        }
    </div>

    @if (
        table?.pagingType !== PAGING_TYPE?.InfiniteScroll &&
        tablePaging?.totalPages > 1
    ) {
        <div class="d-flex justify-content-center flex-shrink-0 pt-2">
            <wdx-pagination
                [page]="tablePaging?.page"
                [collectionSize]="tablePaging?.totalPages"
                [maxSize]="6"
                [scrollContainer]="scrollContainer"
                (pageChange)="onPageChanged($event)"
            ></wdx-pagination>
        </div>
    }
</div>

<ng-template #tableValue let-value="value" let-avatarSize="avatarSize">
    <div
        class="flex-grow-1 text-truncate"
        [ngClass]="value.severity | severity: ['text']"
    >
        @if (
            !value.formSetup &&
            !value.routerLink &&
            !value.externalLink &&
            !value.templateRef
        ) {
            @if (value.values?.length) {
                <div class="table__value">
                    @for (
                        listValue of value.values;
                        track $index;
                        let last = $last;
                        let i = $index
                    ) {
                        <div>
                            @if (
                                value.routerLinks?.length &&
                                value.routerLinks[i].length
                            ) {
                                <a [routerLink]="value.routerLinks[i]">
                                    <ng-container
                                        *ngTemplateOutlet="
                                            valuesListValue;
                                            context: {
                                                value: listValue,
                                                last: last,
                                            }
                                        "
                                    ></ng-container>
                                </a>
                            } @else {
                                <ng-container
                                    *ngTemplateOutlet="
                                        valuesListValue;
                                        context: {
                                            value: listValue,
                                            last: last,
                                        }
                                    "
                                ></ng-container>
                            }
                        </div>
                    }
                    <ng-template
                        #valuesListValue
                        let-value="value"
                        let-last="last"
                    >
                        {{ value }}{{ last ? '' : ',' }}
                    </ng-template>
                </div>
            } @else {
                @if (value.value) {
                    <div
                        class="table__value d-flex align-items-center"
                        [attr.data-cy]="'text-info-' + value.value"
                    >
                        @if (value.icon) {
                            <wdx-icon
                                class="me-2 text-muted align-items-center d-flex icon-container-size-md justify-content-center"
                                [iconStyle]="value.severity ? 'fas' : 'fal'"
                                [severity]="value.severity"
                                [icon]="value.icon"
                            >
                            </wdx-icon>
                        }
                        <div>
                            {{ value.value }}
                        </div>
                    </div>
                }
            }
        }
        @if (value.formSetup) {
            <a
                href="#"
                [clmiUiDynamicFormSetup]="value.formSetup"
                click-prevent-default
                >{{ value.value }}</a
            >
        }
        @if (value.routerLink) {
            <a [routerLink]="value.routerLink" [innerHtml]="value.value"></a>
        }
        @if (value.externalLink) {
            <a class="text-nowrap" target="_blank" [href]="value.externalLink"
                >{{ value.value }}<i class="fal fa-external-link ms-2"></i
            ></a>
        }
        @if (value.templateRef) {
            <ng-container
                *ngTemplateOutlet="
                    value.templateRef;
                    context: { value: value.value, data: value.data }
                "
            ></ng-container>
        }
        @if (value.icon && !value.value) {
            <div class="d-flex">
                <wdx-icon
                    class="align-items-center d-flex icon-container icon-container-size-md justify-content-center no-container rounded-circle"
                    [severity]="value.severity"
                    [icon]="value.icon"
                >
                </wdx-icon>
            </div>
        }
    </div>
    @if (value.avatars) {
        <div class="ms-2">
            <molecule-avatar-group
                [size]="avatarSize"
                [avatars]="value.avatars"
            ></molecule-avatar-group>
        </div>
    }
</ng-template>

<ng-template #rowSelector let-row="row" let-index="index">
    @switch (rowSelectorStyle) {
        @case (CHECKBOX_STYLE.Check) {
            <wdx-checkbox
                [checked]="selectedRows | fn: rowIsSelected : row"
                (isChecked)="onSelectRow(row, $event)"
            ></wdx-checkbox>
        }
        @case (CHECKBOX_STYLE.Toggle) {
            <wdx-switch
                [toggled]="selectedRows | fn: rowIsSelected : row"
                (toggledChanged)="onSelectRow(row, $event)"
            ></wdx-switch>
        }
    }
</ng-template>

<ng-template #rowToggle let-row="row">
    <wdx-icon
        class="ms-1 icon-flip-anti-clockwise-180 icon-animate align-items-center d-flex icon-container icon-container-size-md justify-content-center no-container rounded-circle"
        icon="chevron-down"
    >
    </wdx-icon>
</ng-template>
